import { Check, Dot } from "lucide-react";

const SocialProof = () => {
  return (
    <div className="">
      <div className="flex flex-col gap-1">
        <div className="bg-gradient-to-br from-[rgba(59,130,246,0.1)] to-[rgba(139,92,246,0.1)] border !border-[rgba(59,130,246,0.2)] rounded-2xl px-6 py-7 mb-7 text-center">
          <div className="flex flex-col items-center text-center">
            <p class="text-blue-400 text-[48px] font-bold m-0 tracking-[-0.03em]">
              20+
            </p>
            <p class="text-slate-400 text-sm mt-1 mx-0 mb-0">
              dispatchers using Cinesis today
            </p>
          </div>
        </div>

        <h2 className="text-[30px] font-medium mb-1 text-gray-100">
          Built for small fleets who don't have time to waste
        </h2>

        <div className="flex flex-col gap-3 py-3">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-[rgba(34,197,94,0.15)] flex items-center justify-center shrink-0">
              <Check size={13} color="#22c55e" />
            </div>
            <p className="text-gray-200 text-sm leading-6">
              Faster load search — less tab-switching
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-[rgba(34,197,94,0.15)] flex items-center justify-center shrink-0">
              <Check size={13} color="#22c55e" />
            </div>
            <p className="text-gray-200 text-sm leading-6">
              Lane-fit scoring on every load
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-[rgba(34,197,94,0.15)] flex items-center justify-center shrink-0">
              <Check size={13} color="#22c55e" />
            </div>
            <p className="text-gray-200 text-sm leading-6">
              SMS alerts you can actually act on
            </p>
          </div>
        </div>

        <div className="bg-white/[0.03] rounded-[14px] p-4 border-l-[3px] border-blue-500 mt-2 mb-7">
          <p class="text-slate-200 text-[15px] italic leading-[1.55] m-0">
            "Cuts my morning load search in half."
          </p>

          <p class="text-slate-500 text-[13px] mt-3 mx-0 mb-0">
            — Dispatcher, 8 trucks (TX)
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 p-3.5 bg-white/[0.02] rounded-[10px]">
          <div className="w-4 h-4 rounded-full bg-blue-500 flex items-center justify-center">
            <Dot size={2} color="#000" />
          </div>

          <span class="text-slate-400 text-[13px]">
            Truckstop Marketplace Partner
          </span>
        </div>

        <div className="mt-3 text-center text-gray-500 text-sm">
          <p>Your phone is used only for alerts. No spam, ever.</p>
        </div>
      </div>
    </div>
  );
};

export default SocialProof;
